<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/tR5mPR/Images/9781429962568.jpg?1726444428115" alt="This image is the cover for the book Rule Your Freakin' Retirement"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Rule Your Freakin' Retirement
      </h1>
      <p class="bookDescription body article font2">
        <p><b>DON'T PANIC. RULE!<br/><br/></b>Market turbulence has made opening monthly 401(k) statements shocking rather than reassuring. Michael "Waxie" Parness can help.<br/><br/>The standard strategies and advice regarding your retirement accounts are NOT working. Many people's 401(k)s are now 201(k)s, and it may get worse. YOU need to take control of your retirement, and your life. <i>Rule Your Freakin' Retirement</i>, through practical and pragmatic advice and examples, will teach you alternatives to the "buy, hold, and pray" strategies most investment advisers give. In today's world you need fresh ideas, and this book gives you the tools you need to not only protect what you have in your IRA, but to grow it in an aggressive, time-tested, yet easily managed way. And, yes, a safer way!<br/><br/>Building on his successful <i>Rule the Freakin' Markets</i>, master trader and motivational speaker Michael Parness applies the same aggressive strategies to normally ignored or undermanaged 401(k), IRA, and other retirement accounts. Contrary to conventional wisdom, Parness argues that no matter what age you are, NOW is the time to adopt active, aggressive, and controlled strategies to ensure a fully funded, real retirement on your own terms, not subject to market gyrations out of your control. He outlines, in plain language, bold but practical strategies emphasizing research and tailoring approaches to individual needs.<br/><br/>With record numbers of baby boomers entering or nearing retirement, and succeeding generations caught by a volatile economy, <i>Rule Your Freakin' Retirement</i> offers tangible, proven, no-nonsense advice that all can profit from, in the engaging Waxie style.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michael Parness
      </h2>
      
      <p class="authorDescription body article"><P>Michael Parness is a highly successful full-time master trader and owner of the financial Web site trendfund.com. He has worked with hundreds of thousands of people looking to him for help achieving their own financial freedom. He's also a multi--award winning film producer/director/writer. His homeless to riches life story was optioned by Hollywood. He has appeared on CNBC, CNN FN, Fox News, and Bloomberg, and has been featured in <I>The</I><I>Wall Street Journal</I>, <I>Forbes</I>,<I> Crain's</I>,<I> The New York Times</I>,<I> New York Post</I>, and<I> Financial Times.</I></P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3d70a3d3